import { ScheduleActionType, ScheduleActionTypes } from "./scheduleTypes";


export const getSchedules = (id : number): ScheduleActionType => ({
  type: ScheduleActionTypes.GET_SCHEDULES,payload: {
    data: {
      id
    }
  }
});


export const updateSchedule = (
  id: number,
  weekNumber: number,
  userId: number,
  startTime: string,
  endTime: string,
  onVacation: boolean,
): ScheduleActionType => ({
  type: ScheduleActionTypes.UPDATE_SCHEDULE,
  payload: {
    data:{
      id,
      weekNumber,
      userId,
      startTime,
      endTime,
      onVacation
    }
  
  },
});


export const openModalSchedule = (): ScheduleActionType =>({
    type: ScheduleActionTypes.OPEN_MODAL,
});

export const closeModalSchedule = (): ScheduleActionType =>({
  type: ScheduleActionTypes.CLOSE_MODAL,
});
